import * as React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import { userHasAnyRole } from "@konicaminolta/common-react";
import { User } from "oidc-client";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faExpandAlt, faFilePdf, faFilePowerpoint, faQuestionCircle } from '@fortawesome/pro-solid-svg-icons'
import { WorkItemType } from './UserRequests/dto/WorkItemType';
import UserRequestModal from './UserRequests/UserRequestModal';
import { appSettings } from '../../appSettings';
import { PowerBiObjectType } from '../../types/Common/PowerBiObjectType';
import { AppState } from '../../store';
import * as DashboardStore from '../../store/Dashboard';
import * as ReportStore from '../../store/Report';
import * as PowerBi from 'powerbi-client';
import { ExportFileType } from '../../types/Common/Enums/ExportFileType';


type NavMenuProps = {
    dispatch: Dispatch;
    user: User;
    powerBiObjectType: PowerBiObjectType;
    documentId: string | undefined;
    documentTitle: string | undefined;
    onFullScreenClick?:  (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    showExportFileRequestModal: (exportFileType: ExportFileType) => void;
    dashboardState: DashboardStore.DashboardState;
    reportState: ReportStore.ReportState;
}

interface NavMenuState {
    profileUri: string;
    showUserRequestModal: boolean;
    workItemType: WorkItemType;
    documentTitle: string;
    isDocumentExportable: boolean;
    showExportFileModal: boolean;
    embedObject: PowerBi.Embed | undefined;
}

class NavMenuSharableLink extends React.Component<NavMenuProps, NavMenuState> {
    constructor(props: NavMenuProps) {
        super(props);
        this.dismissUserRequestModal = this.dismissUserRequestModal.bind(this)
        this.state = {
            profileUri: "",
            showUserRequestModal: false,
            workItemType: WorkItemType.Unknown,
            documentTitle: "",
            isDocumentExportable: true,
            showExportFileModal: false,
            embedObject: undefined,
        };
    }

    public componentDidMount() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {
        if (this.props.powerBiObjectType == PowerBiObjectType.Report && this.state.embedObject == undefined) {
            this.setState({embedObject: this.props.reportState.powerBiEmbeddedReport});
        }
    }

    private showUserRequestModal(requestType: WorkItemType) {
        this.setState({
            workItemType: requestType,
            showUserRequestModal: true
        });

    }

    private dismissUserRequestModal() {
        this.setState({ showUserRequestModal: false });
    }

    public render() {
        var initialSubjectIdForReportSupport = "00000000-0000-0000-0000-000000000001"; // Subject Id applied on DSA Team Feature for routing WITH Subject Type
        let isOnDedicatedCapacity = false;
        if (this.props.powerBiObjectType == PowerBiObjectType.Report) {
            let record = this.props.reportState.data.find(x => x.id === this.props.documentId);
            console.log(record);
            isOnDedicatedCapacity = record?.isOnDedicatedCapacity ?? false;
        } else if (this.props.powerBiObjectType == PowerBiObjectType.Dashboard) {
            let record = this.props.dashboardState.data.find(x => x.id === this.props.documentId);
            isOnDedicatedCapacity = record?.isOnDedicatedCapacity ?? false;
        }

        return (
            <React.Fragment>
                <div id="sharedViewNav" className="nav-primary">
                <Navbar collapseOnSelect fixed="top" expand="lg" className="nav-primary flex-lg-nowrap p-0 bg-white">
                
                <Navbar.Brand href="" className="d-flex w-50 me-auto">
                            <img
                                src={appSettings.navLogoAsset}
                                className="logo"
                                alt="Konica Minolta"
                            />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" className="me-2 ml-auto" />
                <Navbar.Collapse id="responsive-navbar-nav" className="w-100 bg-white px-2">
                <Nav className="w-100 justify-content-center">
                    <label>{this.props.documentTitle}</label>
                </Nav>
                <NavDropdown.Divider />
                <Nav className="menu-user ml-auto me-4 w-100 justify-content-end">
                    {/* help nav */}

                    { isOnDedicatedCapacity ?
                        <Nav.Item id="export-to-file" role="menu">
                            <NavDropdown
                                id="export-to-file-dropdown"
                                className='dropdown-menu-right'
                                title={
                                    <span><FontAwesomeIcon className="me-2 text-dark" icon={faDownload} />
                                        Export
                                    </span>
                                }
                                >
                                <NavDropdown.Item onClick={() => this.props.showExportFileRequestModal(ExportFileType.Pdf)}>
                                    <span><FontAwesomeIcon className="me-2 text-dark" icon={faFilePdf} />
                                        PDF
                                    </span>
                                </NavDropdown.Item>
                                <NavDropdown.Item onClick={() => this.props.showExportFileRequestModal(ExportFileType.Pptx)}>
                                    <span><FontAwesomeIcon className="me-2 text-dark" icon={faFilePowerpoint} />
                                        PPTX
                                    </span>
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav.Item>
                        : ''
                    }
                    <Nav.Item id="report-fullscreen" role="button" onClick={this.props.onFullScreenClick}>
                        <div className='nav-link'>
                        <span><FontAwesomeIcon className="me-2 text-dark" icon={faExpandAlt} />Full Screen</span>
                        </div>
                    </Nav.Item>
                    <Nav.Item id="help-nav">
                        <NavDropdown
                            // alignRight
                            align="end"
                            id="help-nav-dropdown"
                            className='dropdown-menu-right'
                            title={
                                <span><FontAwesomeIcon className="me-2 text-dark" icon={faQuestionCircle} />
                                    Help
                                </span>
                            }
                        >
                            <NavDropdown.Item onClick={() => this.showUserRequestModal(WorkItemType.Feature)}>
                                Feature Request
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => this.showUserRequestModal(WorkItemType.Bug)}>
                                Problem Report
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav.Item>
                </Nav>
                </Navbar.Collapse>
                <UserRequestModal
                            isAdmin={userHasAnyRole(this.props.user!, ["b8c2b209-79f5-4ccd-9a52-2af514a8ec65"])}
                            initialSubjectId={initialSubjectIdForReportSupport}
                            isOpen={this.state.showUserRequestModal}
                            handleClose={this.dismissUserRequestModal}
                            workItemType={this.state.workItemType} 
                            powerBiObjectType={this.props.powerBiObjectType}
                            documentId={this.props.documentId}
                            documentName={this.props.documentTitle}
                            />
                </Navbar>
                </div>
            </React.Fragment>
        );
    }
}


function mapStateToProps(state: AppState) {
    return {
      user: state.oidc.user!,
      isLoadingUser: state.oidc.isLoadingUser,
      location: state.router.location,
      dashboardState: state.dashboard,
      reportState: state.report,
    };
  }

  function mapDispatchToProps(dispatch: Dispatch) {
    return {
      dispatch,
    };
  }

export default connect(mapStateToProps, mapDispatchToProps)(NavMenuSharableLink);